module.exports = __webpack_public_path__ + "img/rod_06.54706b9f.svg";